module.exports = __webpack_public_path__ + "img/icon_Google-Play.58d626cc.png";